var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,8a2,2,0,1,0-2,2A2,2,0,0,0,10,8ZM7,8A1,1,0,1,1,8,9,1,1,0,0,1,7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM1,8A7,7,0,0,1,2.72,3.42L5.29,6,4.15,7.15a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0l3-3a.49.49,0,0,0-.7-.7L6,5.29,3.42,2.72a7,7,0,0,1,9.86,9.86L10.71,10l1.14-1.15a.49.49,0,0,0-.7-.7l-3,3a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0L10,10.71l2.58,2.57A7,7,0,0,1,1,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltSign);
export default __webpack_public_path__ + "static/media/Bolt_sign.d931660df248e9c42724262235b709d5.svg";
export { ForwardRef as ReactComponent };